<template>
    <div
        :class="[
            'd-flex justify-content-end',
            align === 'left' ? 'flex-row' : 'flex-row-reverse',
        ]"
        style="gap: var(--space-2)"
    >
        <UserAvatar :user="user" :avatar-image="staticImage" />
        <div
            :class="[
                'd-flex',
                'flex-column',
                'flex-grow-1',
                'message-container',
                `message-container--${align}`,
                { 'message-container--error': isError },
            ]"
        >
            <div v-if="!isError" class="message-author">
                {{ user ? `${user.first_name} ${user.last_name}` : staticName }}
            </div>
            <div v-if="!isError" class="message-date">
                {{ createdDateLocal }}
            </div>

            <!-- all the content is passed in here -->
            <slot name="content" />
        </div>
    </div>
</template>

<script>
import UserAvatar from '@/components/UserAvatar.vue';
import moment from 'moment';

export default {
    name: 'MessageBubble',
    components: {
        UserAvatar,
    },
    props: {
        user: {
            type: Object,
            required: false,
        },
        align: {
            type: String,
            required: false,
            default: 'right',
            validator(value) {
                return ['left', 'right'].includes(value);
            },
        },
        createdAt: {
            type: String,
            required: true,
        },
        staticName: {
            type: String,
            required: false,
        },
        staticImage: {
            type: String,
            required: false,
        },
        isError: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        createdDateLocal() {
            const createdAtLocal = moment.utc(this.createdAt).local();
            return `${createdAtLocal.format(
                'MMM D, YYYY'
            )} • ${createdAtLocal.format('h:mma')}`;
        },
    },
};
</script>

<style scoped>
.message-container {
    padding: var(--space-4);
    gap: var(--space-2);
    border-radius: var(--radius-default);
    width: 100%;
}

.message-container--left {
    background-color: var(--primary-25);
}

.message-container--right {
    background-color: var(--primary-50);
}

.message-container--error {
    background-color: #eddcd7;
}

.message-author {
    font-size: var(--size-4);
    font-weight: 700;
    line-height: 100%;
}

.message-date {
    font-size: 0.875rem;
    line-height: 1.43;
    font-weight: 400;
    color: var(--neutral-900);
}
</style>
